<div class="toggle-container toolbar-item">
    <div (click)="toggleSwitch()" class="divToggleIcon">
        <em class="fas toggle fa-toggle-on" [class.fa-toggle-on]="toggleState" [class.fa-toggle-off]="!toggleState"
            tooltip="Edit mode" i18n-tooltip="@@EditModeToggleTooltip" id="editModeToggle" placement="bottom"></em>
    </div>
</div>
